/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoSearchResult/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function NoSearchResult({
  children,
  viewPath = "/DesignSystem/Images/NoSearchResult",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 300,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 300
  
}) {
  return (<React.Fragment
>
<img
  data-testid="NoSearchResult.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-1tExzA': alignSelf,'--bc-2-1tExzA': backgroundColor,'--bblr-3-1tExzA': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-1tExzA': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-1tExzA': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-1tExzA': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-1tExzA': typeof height === 'number' ? `${height}px` : height,'--mb-8-1tExzA': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-1tExzA': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-1tExzA': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-1tExzA': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-1tExzA': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}